// ─── RN-001: utilitários de data no fuso de São Paulo (UTC-3) ─────────────────

const TZ = "America/Sao_Paulo";

/** "YYYY-MM-DD" de hoje no fuso de São Paulo, independente do fuso do navegador */
export function hojeSP(): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit",
  }).format(new Date());
}

/** Componentes de data/hora atuais em São Paulo (mês 0-indexado) */
export function agoraSP(): { ano: number; mes: number; dia: number; hora: number } {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat("en-CA", {
      timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", hour12: false,
    }).formatToParts(new Date()).map(p => [p.type, p.value])
  );
  return {
    ano: Number(parts.year),
    mes: Number(parts.month) - 1,
    dia: Number(parts.day),
    hora: Number(parts.hour) % 24,
  };
}

/**
 * Formata um timestamp epoch (ms) no fuso de São Paulo.
 * Para strings "YYYY-MM-DD" use formatDataStr().
 */
export function formatTimestampSP(
  ts: number,
  opts: Intl.DateTimeFormatOptions = { day: "2-digit", month: "2-digit", year: "numeric" },
): string {
  return new Intl.DateTimeFormat("pt-BR", { timeZone: TZ, ...opts }).format(new Date(ts));
}

/**
 * Formata uma string de data "YYYY-MM-DD" como data civil (sem deslocamento de fuso).
 * Usa âncora ao meio-dia para evitar rollover de dia.
 */
export function formatDataStr(
  dataStr: string,
  opts: Intl.DateTimeFormatOptions = { day: "2-digit", month: "short" },
): string {
  return new Date(dataStr.substring(0, 10) + "T12:00:00").toLocaleDateString("pt-BR", opts);
}
